// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from './service/auth/http'
import Vuelidate from 'vuelidate'
import MuseUI from 'muse-ui'
import './components/theme/current.less'

// import vueg from 'vueg'
// import 'vueg/css/transition-min.css'
import 'typeface-roboto'
import 'vue2-animate/dist/vue2-animate.min.css'
import Croppa from 'vue-croppa'
import 'vue-croppa/dist/vue-croppa.css'
import store from './vuex/store'
import settings from './config/settings'
import commonVariable from './config/commonVariable'
import VTooltip from 'v-tooltip'
// import VueQrcode from '@chenfengyuan/vue-qrcode'
// import VueMasonry from 'vue-masonry-css'
import Meta from 'vue-meta'
import Notifications from 'vue-notification'
import siteUtil from './plugins/siteUtil'
import VueGtag from 'vue-gtag'

import theme from 'muse-ui/lib/theme'
import VueFacebookPixel from 'vue-analytics-facebook-pixel'
theme.add('current', {
  primary: '#000000',
  secondary: '#002855'
  // success: '#4caf50',
  // warning: '#ffeb3b'
})

theme.use('current')

MuseUI.Select.mixins[1].props.noDataText.default = 'No Data Available'

// const vuegOptions = {
//   duration: '0.3',              // 转场动画时长，默认为0.3，单位秒
//   firstEntryDisable: false,     // 值为true时禁用首次进入应用时的渐现动画，默认为false
//   firstEntryDuration: '.6',     // 首次进入应用时的渐现动画时长，默认为.6
//   forwardAnim: 'fadeInRight',   // 前进动画，默认为fadeInRight
//   backAnim: 'fadeInLeft',       // 后退动画，默认为fedeInLeft
//   sameDepthDisable: true,      // url深度相同时禁用动画，默认为false
//   // tabs: [{
//   //   name:'home'
//   // },{
//   //   name:'my'
//   // }],                       // 默认为[]，'name'对应路由的name,以实现类似app中点击tab页面水平转场效果，如tabs[1]到tabs[0]，会使用backAnim动画，tabs[1]到tabs[2]，会使用forwardAnim动画
//   tabsDisable: false,           // 值为true时，tabs间的转场没有动画，默认为false
//   shadow: true,                  // 值为false，转场时没有阴影的层次效果
//   disable: false               // 禁用转场动画，默认为false，嵌套路由默认为true
// }

Vue.prototype.$http = axios
Vue.prototype.$settings = settings
Vue.use(Vuelidate)
Vue.use(MuseUI)
// Vue.use(router)
Vue.use(VueGtag, {
  config: { id: 'G-32Y2CCNXJN' }
}, router)
Vue.use(Croppa)
Vue.use(VTooltip)
// Vue.use(VueMasonry)
Vue.use(Meta)
Vue.use(Notifications)
Vue.use(siteUtil)
// add google analytics tracking code
// Vue.use(VueAnalytics, {
//   id: 'UA-54985207-7',
//   checkDuplicatedScript: true,
//   router,
//   debug: {
//     // enabled: process.env.NODE_ENV !== 'production',
//     // trace: process.env.NODE_ENV !== 'production',
//     sendHitTask: process.env.NODE_ENV === 'production'
//   }
//   // autoTracking: {
//   //   exception: true,
//   //   exceptionLogs: false
//   // }
// })
Vue.use(VueFacebookPixel)
Vue.analytics.fbq.init('827564204664748')
Vue.analytics.fbq.event('PageView')

Vue.config.productionTip = false
Vue.prototype.$commonVariable = commonVariable

/* eslint-disable no-new */
window.app = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  data: {
    // Uh oh - appName is *also* the name of the
    // instance property we defined!
    appName: 'Mondo CheckIn Portal'
  }
})

export default window.app



// WEBPACK FOOTER //
// ./src/main.js